import { render, staticRenderFns } from "./IndexRightInfo.vue?vue&type=template&id=9e4cd522"
import script from "./IndexRightInfo.vue?vue&type=script&lang=js"
export * from "./IndexRightInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports